type ReplacementRule = {
  pattern: RegExp;
  replacement: string;
};

export function convertSlackMarkdownToHtml(markdown: string): string {
  if (!markdown) {
    return '';
  }
  // Define replacement rules
  const rules: ReplacementRule[] = [
    // Bold: *text* -> <strong>text</strong>
    {
      pattern: /\*(.*?)\*/g,
      replacement: '<strong>$1</strong>',
    },
    // Italic: _text_ -> <em>text</em>
    {
      pattern: /_(.*?)_/g,
      replacement: '<em>$1</em>',
    },
    // Bullet points: - text -> <li>text</li>
    {
      pattern: /^-\s*(.*?)$/gm,
      replacement: '<li>$1</li>',
    },
    // Line breaks: \n\n -> <br/>
    {
      pattern: /\n/g,
      replacement: '<br/>',
    },
    {
      pattern: /\\n/g,
      replacement: '<br/>',
    },
  ];

  // Apply each replacement rule
  let html = markdown;
  rules.forEach((rule) => {
    html = html.replace(rule.pattern, rule.replacement);
  });

  // Wrap bullet points in unordered list tags
  if (html.includes('<li>')) {
    html = '<ul>\n' + html + '\n</ul>';
  }

  return html;
}

// Test utility function
function testConverter() {
  const input = `- Use *bold* for key points and sections

- Use bullet points for steps/examples

- Use _italic_ for examples

- Add line breaks for readability for each bullet point and category`;

  const expectedOutput = `<ul>
<li>Use <strong>bold</strong> for key points and sections</li>
<li>Use bullet points for steps/examples</li>
<li>Use <em>italic</em> for examples</li>
<li>Add line breaks for readability for each bullet point and category</li>
</ul>`;

  const result = convertSlackMarkdownToHtml(input);
  console.log('Input:', input);
  console.log('Output:', result);
  console.log('Expected:', expectedOutput);
  console.log('Test passed:', result === expectedOutput);
}
